module.exports = __webpack_public_path__ + "static/img/icons.4145eff.svg";


//////////////////
// WEBPACK FOOTER
// ./~/trumbowyg/dist/ui/icons.svg
// module id = 662
// module chunks = 1